module.exports = __webpack_public_path__ + "static/img/app_bg1.c5e23cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg1.jpg
// module id = Fwto
// module chunks = 0